let isDate = function (input) {
  if (!input) return false;

  try {
    const date = new Date(input);
    if (date == "Invalid Date") {
      return false;
    }
    return true;
  } catch (error) {
    return false;
  }
};

export default isDate;
